import { css } from "styled-components";

export const CSS_Notifications = css`
  #chakra-toast-manager-top-right {
    padding-top: 100px;
    padding-right: 0px;
    gap: 0.5rem;
  }

  #chakra-toast-manager-top {
    padding-top: 20px;
    gap: 0.5rem;
  }

  .chakra-toast__inner {
    margin: unset !important;
    padding-right: 1.438rem;
    padding-left: 1.438rem;
  }

  .chakra-alert {
    width: 23.01rem !important;
    font-size: 0.875rem !important;
    padding: 0.75rem !important;
  }
`;
